import { Document, Font, Page, Image, StyleSheet, Text, View } from "@react-pdf/renderer";
import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import QRCode from "qrcode";

Font.register({
  family: "Vazir",
  src: "/fonts/Vazirmatn-FD-Medium.ttf",
});

const PdfLicensePage = ({ data }) => {
  const styles = StyleSheet.create({
    page: {
      padding: 20,
      fontSize: 10,
      fontFamily: "Vazir",
    },
    section2: {
      marginBottom: 10,
    },
    section: {
      padding: 10,
      border: "1pt solid black",
      borderRadius: 5,
    },
    row: {
      flexDirection: "row",
      flexWrap: "wrap",
      justifyContent: "space-between",
    },
    row3: {
      width: "100%",
      justifyContent: "flex-end",
      flexDirection: "row",
      flexWrap: "wrap",
    },
    item: {
      width: "100%",
      marginBottom: 8,
      textAlign: "right",
      direction: "rtl",
    },
    item2: {
      marginBottom: 8,
      textAlign: "right",
      direction: "rtl",
    },
    textRight: {
      textAlign: "right",
      direction: "rtl",
      justifyContent: "right",
    },
    textRight2: {
      textAlign: "right",
      direction: "ltr",
      fontSize: 16,
    },
    footer: {
      textAlign: "center",
      borderTop: "1pt solid black",
      paddingTop: 10,
      marginTop: 10,
    },
    header: {
      textAlign: "right",
      direction: "rtl",
      marginBottom: 10,
      alignSelf: "flex-end",
    },
    row2: {
      flexDirection: "row",
      justifyContent: "space-between",
      alignItems: "center",
      marginBottom: 10,
    },
    qrCode: {
      width: 80,
      height: 80,
    },
    Right: {
      textAlign: "right",
      direction: "rtl",
    },
    title: {
      textAlign: "center",
      fontSize: 14,
      marginBottom: 10,
      fontWeight: "bold",
    },
  });
  const parsePelak = (pelak) => {
    if (!pelak) return null;

    const part1 = pelak.slice(0, 2);
    const part2 = pelak.slice(2, 3);
    const part3 = pelak.slice(3, 6);
    const part4 = pelak.slice(6);

    return { part1, part2, part3, part4 };
  };
  const chunkArray = (array, size) => {
    const result = [];
    for (let i = 0; i < array.length; i += size) {
      result.push(array.slice(i, i + size));
    }
    return result;
  };

  const [qrCodes, setQrCodes] = useState([]);

  useEffect(() => {
    const generateQRCodes = async () => {
      try {
        const qrCodePromises = data.map(async (item) => {
          const qrData = await QRCode.toDataURL(item.cargo_code);
          return qrData;
        });

        const generatedQRCodes = await Promise.all(qrCodePromises);
        setQrCodes(generatedQRCodes);
      } catch (err) {
        console.error("Error generating QR Codes:", err);
      }
    };

    if (data && data.length > 0) {
      generateQRCodes();
    }
  }, [data]);

  const pages = chunkArray(data, 2);

  return (
    <Document>
      {pages.map((pageItems, pageIndex) => (
        <Page size={[226.8, "720"]} style={styles.page} key={pageIndex}>
          {pageItems.map((item, ind) => (
            <View style={styles.section2} key={ind}>
              <Text style={styles.title}>{process.env.REACT_APP_PDF_TITLE}</Text>
              <View style={styles.row2}>
                {qrCodes[ind] && <Image src={qrCodes[ind]} style={styles.qrCode} />}
                <Text style={styles.textRight2}>مجوز بارگیری</Text>
              </View>

              <View style={styles.section}>
                <View style={styles.row}>
                  <Text style={styles.item}>شماره حواله: {item.cargo_code}</Text>
                  <Text style={styles.item}>نوع عملیات: {item.type}</Text>

                  <Text style={styles.item}>
                    تاریخ: {item.date ? item.date.split(" ")[0].split("-").reverse().join("-") : "--"}
                  </Text>
                  <Text style={styles.item}>ساعت: {item.date?.split(" ")[1]}</Text>
                </View>

                <View style={styles.row}>
                  <Text style={styles.item}>نوع دستگاه: {item.machine?.type || "--"}</Text>
                  <Text style={styles.item}>نام دستگاه: {item.machine?.name || "--"}</Text>
                  <View style={styles.row3}>
                    <Text style={styles.item2}>
                      {item.machine.pelak
                        ? ` ${parsePelak(item.machine.pelak)?.part4} ${parsePelak(item.machine.pelak)?.part3} ${parsePelak(item.machine.pelak)?.part2} ${parsePelak(item.machine.pelak)?.part1}`
                        : "--"}
                    </Text>
                    <Text style={styles.item2}>پلاک: </Text>
                  </View>
                  <Text style={styles.item}>محل استقرار: {item.location?.name || "--"}</Text>
                </View>

                <View style={styles.row}>
                  <Text style={styles.item}>شیفت: {item.shift?.name || "--"}</Text>
                  <Text style={styles.item}>مدت زمان بارگیری: {item.duration || "--"}</Text>

                  <Text style={styles.item}>تجهیز بارگیری: {item.equipment?.name || "--"}</Text>
                  <Text style={styles.item}>اپراتور: {item.operator?.name || "--"}</Text>
                </View>

                {item.jens &&
                  item.jens.length > 0 &&
                  item.jens.map((jensItem, jensIndex) => (
                    <View key={jensIndex} style={styles.row}>
                      <Text style={styles.item}>وزن: {jensItem["weight_unit"] || "--"}</Text>
                      <Text style={styles.item}>واحد: {jensItem["weight"]["title"] || "--"}</Text>

                      <Text style={styles.item}>تعداد: {jensItem["jens_unit"] || "--"}</Text>
                      <Text style={styles.item}>شماره کالا: {jensItem["jens_number"] || "--"}</Text>

                      <Text style={styles.item}>کالا: {jensItem["title"] || "--"}</Text>
                      <Text style={styles.item}>کد کالا: {jensItem["jens_code"]["title"] || "--"}</Text>
                    </View>
                  ))}

                <View style={styles.row}>
                  <Text style={styles.item}>پروژه: {item.project?.title || "--"}</Text>
                  <Text style={styles.item}>هزینه کل عملیات: {item.sum_amount_with || "--"}</Text>
                  <Text style={styles.item}>کرایه: {item.amount_with || "--"}</Text>
                  <Text style={styles.item}>راننده: {item.driver?.name || "--"}</Text>

                </View>

                <View style={styles.row}>
                  <Text style={styles.item}>توضیحات: {item.desc}</Text>
                  <Text style={styles.item}>مبدا: {item.origin?.title || "--"}</Text>
                  <Text style={styles.item}>مقصد: {item.destination?.title || "--"}</Text>
                  <Text style={styles.item}>پیمانکار: {item.peymankar?.name || "--"}</Text>

                </View>
              </View>

              <Text style={styles.footer}>
                (نرم افزار مدیریت بارگیری بارگو) 91096293-021 www.bargosoftware.com
              </Text>
            </View>
          ))}
        </Page>
      ))}
    </Document>
  );
};

export default PdfLicensePage;

PdfLicensePage.propTypes = {
  data: PropTypes.array,
};